import React, { useEffect, useCallback } from 'react';
import './CriteriasPanel.css';
import { FormProvider, useForm } from 'react-hook-form';
import Slugify from '@js/utils/Slugify';
import { ReactComponent as IconClose } from '@icons/close.svg';

function CriteriasPanel({
  criterias,
  toggleCriterias,
  setToggleCriterias,
  setActiveColumns
}) {
  const methods = useForm({
    defaultValues: {
      activeColumns: criterias
    }
  });

  const onValid = ({ activeColumns }) => {
    setActiveColumns(activeColumns);
    setToggleCriterias(false);
  };

  const onOutsideClick = useCallback((e) => {
    if (!e.target.closest('.OverlayFilters')) setToggleCriterias(false);
  }, [setToggleCriterias]);

  useEffect(() => {
    if (toggleCriterias) {
      document.body.classList.add('overflow-hidden');
      document.body.classList.add('is-open');
      document.addEventListener('click', onOutsideClick);
    }
    else {
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('is-open');
      document.removeEventListener('click', onOutsideClick);
    }
  }, [toggleCriterias, setToggleCriterias, onOutsideClick]);

  return (
    <FormProvider {...methods}>
      <div className={`CriteriasPanel OverlayFilters ${toggleCriterias ? 'open' : ''}`}>
        <div className="flex justify-between w-full OverlayFilters-header">
          <p className="font-semibold">Critères</p>
          <button onClick={() => {
            setToggleCriterias(false);
          }}>
            <IconClose className="w-6 h-6"/>
          </button>
        </div>
        <form
          className="flex flex-col flex-1 overflow-hidden CriteriasPanel-form"
          onSubmit={methods.handleSubmit(onValid)}>
          <div className="OverlayFilters-items">
            {criterias.map((criteria) => (
              <div
                className="CriteriasPanel-input"
                key={criteria}>
                <input
                  type="checkbox"
                  {...methods.register('activeColumns')}
                  id={Slugify(criteria)}
                  className="Checkbox"
                  value={criteria}
                />
                <label className="ml-3 leading-tight cursor-pointer" htmlFor={Slugify(criteria)}>
                  {criteria}
                </label>
              </div>
            ))}
          </div>
          <div className="mt-auto OverlayFilters-footer active">
            <button
              type="button"
              className="OverlayFilters-footerReset"
              onClick={() => {
                methods.setValue('activeColumns', criterias);
                setActiveColumns(criterias);
                setToggleCriterias(false);
              }}>Réinitialiser les critères</button>
            <button
              type="submit"
              className="ml-auto OverlayFilters-footerBtn btn btn--rounded">Valider</button>
          </div>
        </form>
      </div>
    </FormProvider>
  )
};

export default CriteriasPanel;
